export const proposalsKeys = {
  base: ["proposals"],

  proposalsParams: (params: Record<string, number | string | undefined>) => [
    ...proposalsKeys.base,
    "params",
    params,
  ],
};
